<template src="../templates/search-box.html" />

<script setup>

import { defineProps, toRefs } from 'vue';
import debounce from 'lodash/debounce';
import { showFilterPopup } from '../config/config.js';

const props = defineProps({
    searchQuery: {
        type: String,
        required: true,
    },
    // eslint-disable-next-line
    layoutType: {
        type: String,
    },
    isIllinoisMade: {
        type: Boolean,
    },
});

const {
    searchQuery,
    layoutType,
} = toRefs(props);

// eslint-disable-next-line
const emit = defineEmits(['update:searchQuery']);

const debouncedSearch = debounce((query) => {

    emit('update:searchQuery', query);

}, 1000); // Delay for 1000ms (1 second)

const handleSearchInput = () => {

    debouncedSearch(searchQuery.value);

};

</script>
